import { useQuery } from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';
import { QueryKey } from '@shared/config';

export const useGetVacancyTariffs = () => {
  return useQuery({
    queryKey: [QueryKey.GET_VACANCY_TARIFFS],
    queryFn: () => vacancyApi.getVacancyTariffs(),
  });
};
